import { Fragment } from 'react/jsx-runtime'
import { useVersionCheck } from '@/hooks/useCheckAppVersion'
import { Dialog } from '@mui/material'
import { useAuthContext } from '@/features/auth/context'
import ConfirmModalUI from '@/components/common/ConfirmModalUI/ConfirmModalUI'

const VersionCheck = () => {
  const { isLogin } = useAuthContext()

  const { shouldReload, handleReload, handleSnooze } = useVersionCheck(30000)

  const onCloseConfirm = () => {
    handleReload()
  }

  const onClose = () => {
    handleSnooze()
  }

  if (!isLogin) return null

  return (
    <Fragment>
      <Dialog open={shouldReload} onClose={onCloseConfirm}>
        <ConfirmModalUI
          title="New Version Available"
          text="A newer version of this app is available. To get the latest updates and improvements, please reload the page."
          confirmText="Reload"
          cancelText="Later"
          onConfirm={onCloseConfirm}
          onClose={onClose}
        />
      </Dialog>
    </Fragment>
  )
}

export default VersionCheck
